import { getGrades } from "@/api/grading";
import { useQuery } from "@tanstack/react-query";

export function useGradesQuery() {
  return useQuery({
    queryKey: ["grades"],
    queryFn: async () => {
      const response = await getGrades();
      return response.data;
    },
  });
}
